var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',_vm._l((_vm.computedParams),function(computedParam){return _c('v-col',{key:computedParam.param_id,attrs:{"align-self":"center","cols":"3"}},[_c('ComputedParam',{attrs:{"computedParam":computedParam}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }